<div class="container">
  <div class="main">
    <mat-expansion-panel class="nrg-sidebar-panel" *ngFor="let item of items(); let i = index" [class.has-active-item]="hasActiveChild(item)" [expanded]="expandedPanels.has(i)" (opened)="onPanelOpened(i)" (closed)="onPanelClosed(i)">
      <mat-expansion-panel-header>
        <mat-panel-title class="nrg-sidebar-panel-title"><mat-icon style="margin-right: 4px;">{{ item.iconName }}</mat-icon> {{ item.displayName }}</mat-panel-title>
      </mat-expansion-panel-header>
      <mat-nav-list>
        <div class="nrg-sidebar-panel-item" *ngFor="let child of item.children" [class.no-route]="!child.route">
          <a [routerLink]="child.route"
             [class.active-item]="isItemActive(child)"
             class="nrg-sidebar-link"
             [class.disabled]="!child.route"
             [style.cursor]="!child.route ? 'default' : 'pointer'"
             (click)="!child.route && $event.preventDefault()">
            <span matListItemTitle>{{ child.displayName }}</span>
          </a>
        </div>
      </mat-nav-list>
    </mat-expansion-panel>
  </div>
</div>
